/* eslint-disable import/no-duplicates */
import React, { useState } from 'react';
import { format, subDays, isToday } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Chart } from 'react-google-charts';
import { useCurrentEffect } from '../../../../../../../../lib/use-current-effect';

import {
  getMeasurementsByDateRange,
  getLastMeasurementsInfo,
} from '../../../../../../../../services/metrics';
import { usePatient } from '../../../../../../../../hooks/patient';

import Img from '../../../../../../../../assets/images/passos.svg';

import Default, { ShowScreenType } from '../_Default';
import { ChartsProps } from '../../MetricView';
import { DetailsChart } from '../../MetricView/styles';
import { MetricTypeEnum } from '../../../../../../../../enums/MetricTypeEnum';

const StepChart: React.FC<ChartsProps> = ({ dateRange }) => {
  const { patient } = usePatient();

  const [showScreen, setShowScreen] = useState<ShowScreenType>('loading');
  const [dataOneDay, setDataOneDay] = useState<string | number>();
  const [graphData, setGraphData] = useState<(string | number)[][]>([]);

  useCurrentEffect(
    (isCurrent) => {
      (() => {
        if (patient?.id) {
          if (isCurrent()) {
            setShowScreen('loading');
          }

          const { startDate, endDate } = dateRange;

          if (startDate === endDate) {
            getLastMeasurementsInfo({
              patientId: patient.id,
              metrics: [MetricTypeEnum.STEPS],
            })
              .then((response) => {
                const checkMeasurementToday = response.find(
                  (item) =>
                    item.metricType === MetricTypeEnum.STEPS &&
                    isToday(new Date(item.mensuramentDate)),
                );

                if (isCurrent()) {
                  if (checkMeasurementToday) {
                    setShowScreen('chart');
                    setDataOneDay(checkMeasurementToday.steps);
                  } else {
                    setShowScreen('noData');
                  }
                }
              })
              .catch(() => {
                if (isCurrent()) {
                  setShowScreen('noData');
                }
              });
          } else {
            getMeasurementsByDateRange({
              patientId: patient.id,
              metrics: MetricTypeEnum.STEPS,
              startDate,
              endDate,
            })
              .then((response) => {
                if (isCurrent()) {
                  if (response.length > 0) {
                    const result = response.map(
                      ({ steps, mensuramentDate }) => [
                        format(new Date(mensuramentDate), "dd'/'MM"),
                        steps,
                      ],
                    );

                    if (result.length === 1) {
                      const date = new Date(response[0].mensuramentDate);
                      const dayOne = format(
                        new Date(subDays(date, 1)),
                        "dd'/'MM'/'yyyy",
                      );
                      const dayTwo = format(
                        new Date(subDays(date, 2)),
                        "dd'/'MM'/'yyyy",
                      );

                      result.unshift([dayOne, 0]);
                      result.unshift([dayTwo, 0]);
                    }

                    setShowScreen('chart');
                    setGraphData(result);
                  } else {
                    setShowScreen('noData');
                  }
                }
              })
              .catch(() => {
                if (isCurrent()) {
                  setShowScreen('noData');
                }
              });
          }
        }
      })();
    },
    [dateRange, patient],
  );

  return (
    <Default showScreen={showScreen}>
      {dateRange.startDate === dateRange.endDate ? (
        <DetailsChart>
          <h2>
            {`Hoje - ${format(dateRange.startDate, "dd'/'MM", {
              locale: ptBR,
            })}`}
          </h2>

          <div>
            <img src={Img} alt="icone de passos" />

            <div>
              <span>Hoje o paciente deu</span>

              <h1>{dataOneDay}</h1>

              <span>passos</span>
            </div>
          </div>
        </DetailsChart>
      ) : (
        <Chart
          width="100%"
          height="300px"
          chartType="Bar"
          options={{
            legend: { position: 'none' },
            colors: ['#1F80B7'],
          }}
          data={[['', 'Passos'], ...graphData]}
          rootProps={{ 'data-testid': '6' }}
        />
      )}
    </Default>
  );
};

export default StepChart;
